// extracted by mini-css-extract-plugin
export default {"root":"CommentsAndReviews_root__ZWSF7","tab":"CommentsAndReviews_tab__n6uh5","tabTitle":"CommentsAndReviews_tabTitle__WRsqA"};